import * as React from 'react';
import { getHelpLogger } from '../../../../web/utils/getHelpLogger';
import { SignInButtonContainer } from '../containerComponents/SignInButtonContainer';
import { UnAuthIntentGraphContainer } from '../containerComponents/UnAuthIntentGraphContainer';

interface ISignInScenarioProps {
  dispatchSignInUserIntoClientApp: () => void;
  userIsSigningIntoClientApp: boolean;
  showModalitiesStickyFooter: boolean;
  isGetHelp: boolean;
}

export class SignInScenario extends React.Component<ISignInScenarioProps> {
  public constructor(props: ISignInScenarioProps) {
    super(props);
  }

  public render() {
    if (this.props.userIsSigningIntoClientApp) {
      return <div className="loader" />;
    } else {
      return (
        <div onClick={this.props.isGetHelp ? this.tryLogUnAuthDialogLinkClick : undefined}>
          {!this.props.showModalitiesStickyFooter && <SignInButtonContainer />}
          <UnAuthIntentGraphContainer />
        </div>
      );
    }
  }

  public componentDidUpdate() {
    if (this.props.userIsSigningIntoClientApp) {
      this.props.dispatchSignInUserIntoClientApp();
    }
  }

  private tryLogUnAuthDialogLinkClick: React.MouseEventHandler<HTMLDivElement> = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!!event && !!event.target) {
      const target = event.target as HTMLElement;
      if (target.hasAttribute('data-log-click')) {
        const href = target.hasAttribute('href') ? target.getAttribute('href') : '';
        getHelpLogger.logUnAuthSupportTicketLinkClicked(target.getAttribute('data-log-click'), href);
      }
    }
  };
}
